<!--
* UIID: 
* UI Name: Folder DropDown Menu
* Modify Date: 2020/10/07
-->
<template>
  <div class="text-center">
    <v-menu
      offset-y
      :close-on-content-click="false"
      v-model="value"
    >
      <template v-slot:activator="{ on }">
        <span
          v-on="on"
          class="cursor-pointer"
        >
          <v-icon x-small>fa fa-ellipsis-h</v-icon>
        </span>
      </template>
      <v-list
        dense
        class="list-folder"
      >
        <v-list-item
          v-for="(item, index) in getItems"
          :key="index"
        >
            <v-list-item-content v-if="item.code == 'D'" class="pt-0 pb-0">
              <dialogWindow
                size="max"
                title="Delete"
                :btnIcon="item.icon"
                :btnTxt="item.content"
                :info="getDataValue.name"
                detail="Would you like remove this file?"
                :dataValue="getDataValue"
                color="error"
                @select-ok="okEvent($event, item.code)"
              >
              </dialogWindow>
            </v-list-item-content>
            <v-list-item-content v-else class="pt-0 pb-0">
              <v-btn
                small
                text
                @click="okEvent($event, item.code)"
              >
                <v-icon x-small text class="mr-3">{{item.icon}}</v-icon>
                {{ item.content }}<v-spacer></v-spacer>
              </v-btn>
            </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>


<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'

export default {
  components: {
    dialogWindow,
  },
  props: {
    items: {
      type: Array,
      default: () => [
        { content: 'Open', code: "O", icon: 'fa fa-folder-open'  },
        { content: 'Download', code: "L", icon: 'fa fa-arrow-alt-circle-down'  },
        { content: 'Copy', code: "C", icon: 'fa fa-copy'  },
        { content: 'Move', code: "M", icon: 'fa fa-arrow-alt-circle-right' },
        { content: 'Delete', code: "D", icon: 'fa fa-trash'  },
        { content: 'Rename', code: "R", icon: 'fa fa-sync'  },
      ]
    },
    dataValue: {
      default: Object
    },
  },
  data() {
    return {
      value: false
    }
  },
  computed: {
      getItems() {
          return this.items;
      },
      getDataValue() {
        return this.dataValue;
      }
  },
  methods: {
      okEvent(item, code) {
          let result = Object;
          result.value = item;
          result.code = code;
          this.$emit("click-event", result);
          this.value = false;
      },
  },
}
</script>

<style>
.theme--light .list-folder .v-btn span.v-btn__content {
    color: #606268;
}
.theme--dark .list-folder {
    background-color: #191a21;
}
</style>